/**
 * @fileoverview System adapter for the shared ScheduleManager service port —
 *             binds the local-first systemReportScheduleService to the ui-admin
 *             ScheduleServicePort contract.
 * @module system-web/services/systemReportScheduleServicePort
 *
 * Responsibilities: - Map ScheduleServicePort calls onto the system schedule
 *                     service (list/create/delete/set-active).
 * Dependencies:     - ./systemReportScheduleService (Dexie local-first),
 *                     @firesquirrel/ui-admin (ScheduleServicePort type).
 * Architecture:     - Thin adapter only — persistence and audit stay in
 *                     systemReportScheduleService; the port exists so the shared
 *                     ui-admin ScheduleManager never imports host services.
 * Notes:            - Mirrors tenantScheduleServicePort (tenant-web).
 */

import type { ScheduleServicePort } from '@firesquirrel/ui-admin';
import {
  listReportSchedules,
  createReportSchedule,
  deleteReportSchedule,
  updateReportSchedule,
} from './systemReportScheduleService';

/**
 * @contract systemScheduleServicePort
 * Purpose: ScheduleServicePort implementation over the system schedule service.
 * Sync:    local-first; all writes go Dexie → audit → background sync.
 */
export const systemScheduleServicePort: ScheduleServicePort = {
  listSchedules: (reportDefinitionId) =>
    listReportSchedules({ reportDefinitionId }),
  createSchedule: (input) => createReportSchedule(input),
  deleteSchedule: (id) => deleteReportSchedule(id),
  setScheduleActive: (id, isActive) => updateReportSchedule(id, { isActive }),
};
